import React from "react"
import { useEffect, useState } from "react"
import styled from "@emotion/styled"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

const MoreTopics = props => {
  const showMoreTopics = () => {
    props.showMoreTopics()
  }

  const ShowMoreButton = styled.button`
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 26px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: #ffffff;
  `

  const Container = styled.div`
    height: 326px;
    width: 330px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.15);
    @media screen and (max-width: 712px) {
      ax-width: 327px;
      ax-height: 369px;
      margin-right: 0px;
      margin-top: 24px;
    }
    @media screen and (min-width: 712px) {
      max-height: 172px;
      width: 680px;
      align-items: left;
      flex-direction: row;
    }
  `
  const useWindowWidth = () => {
    const isBrowser = typeof window !== "undefined"
    const [width, setWidth] = useState(isBrowser ? window.innerWidth : 0)

    useEffect(() => {
      if (typeof window === "undefined") {
        return <></>
      }

      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener("resize", handleResize)

      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }, [])

    return width
  }

  const windowsWidth = useWindowWidth()

  if (windowsWidth < 712) {
    return (
      <div className="topicColumn">
        <Container onClick={() => showMoreTopics()}>
          <ShowMoreButton>
            過去のトピックス
            <ChevronRightIcon alt="過去のトピックス" width={24} />
          </ShowMoreButton>
        </Container>
      </div>
    )
  } else {
    return (
      <div className="topicColumn">
        <Container onClick={() => showMoreTopics()}>
          <ShowMoreButton>
            過去のトピックス
            <ExpandMoreIcon alt="過去のトピックス" width={24} />
          </ShowMoreButton>
        </Container>
      </div>
    )
  }
}

// Contentful連携
// const TopicsLink = ({ topic }) => {
//     const { title, updatedAt, image } = topic
//     const description = topic.description.description
//     const pageLink = `topics/${topic.slug}/`

//     return (
//         <StyledLink to={pageLink}>
//             <Container>
//                 <div>
//                     <Image src={image.file.url} alt="topic-cover"></Image>
//                 </div>
//                 <ContainerText>
//                     <PublishedDate>{updatedAt}</PublishedDate>
//                     <Title>{title}</Title>
//                     <TagButton>{category}</TagButton>
//                 </ContainerText>
//             </Container>
//         </StyledLink>
//     )
// }

export default MoreTopics
